/**
 * Events Service
 * Handles event-related API operations
 */

import apiClient from "./api";

class EventsService {
  /**
   * Get list of all events
   * @returns {Promise<Array>} Array of events
   */
  async getEvents() {
    const response = await apiClient.get("/events");
    
    if (!response.success) {
      throw new Error(response.message || "Failed to fetch events");
    }
    
    return response.data.events || [];
  }

  /**
   * Get single event by code
   * @param {string} eventCode - Event code
   * @returns {Promise<Object>} Event data
   */
  async getEvent(eventCode) {
    const response = await apiClient.get(`/events/${eventCode}`);
    
    if (!response.success) {
      throw new Error(response.message || "Failed to fetch event");
    }
    
    return response.data;
  }

  /**
   * Get list of events that have at least one lead (for admins)
   * @returns {Promise<Array>} Array of events with leads
   */
  async getEventsWithLeads() {
    const response = await apiClient.get("/events/with-leads");
    
    if (!response.success) {
      throw new Error(response.message || "Failed to fetch events with leads");
    }
    
    return response.data.events || [];
  }
}

export const eventsService = new EventsService();
export default eventsService;
